import * as ApiRoutes from "../../../routes/routeConstants/apiRoutes";
import { Students } from "../../../models/V2/InstituteModel/students.model";
import { deserialize } from "serializr";
import Notification from "../../../shared/components/Notification";
import { NotificationTypes } from "../../../enums/notificationTypes";
import { PaginationModel } from "../../../models/PaginationModel/pagination.model";
import v2AxiosInstance from "../../../interceptor/v2AxiosInstance";

export default class StudentService {
  static fetchStudents(
    params: any,
    onSuccess: Function,
    onError: Function,
    onFinal: () => void
  ) {
    v2AxiosInstance
      .get(ApiRoutes.STUDENTS_LIST, { params })
      .then((response) => {
        const students = deserialize(Students, response?.data["students"]);
        const meta = deserialize(PaginationModel, response?.data["meta"]);
        onSuccess(students, meta);
      })
      .catch((error) => {
        Notification({
          message: "Problem in fetching students",
          description: "Please proceed with valid data!",
          type: NotificationTypes.ERROR,
        });
        onError();
      })
      .finally(() => {
        onFinal();
      });
  }
}
